import { DatePickerAdapter } from 'components/enhanced/form/adapters/date-time/DatePickerAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { IPurchaseRequestRow } from '../../types';

interface ContractPurchaseRequestLineParams {
  purchaseRequestLine: IPurchaseRequestRow;
  contracts: Option[];
  onSubmit: any;
}

function EditAutomaticPurchaseRequestLine(params: ContractPurchaseRequestLineParams) {
  const { t } = useTranslation();
  const { purchaseRequestLine, contracts, onSubmit } = params;

  return (
    <div>
      <div className="align-middle p-2">
        <EnhancedForm onSubmit={onSubmit} formId="editPurchaseRequestLine" hideControls>
          <div className="p-2 ">
            <IdentityField
              name="contract"
              label={t('global.contract')}
              component={AutocompleteAdapter}
              options={contracts}
              type="text"
              optionValue="code"
              initValue={
                purchaseRequestLine.contract
                  ? contracts.find((c) => c.code === purchaseRequestLine.contract.toString())
                  : null
              }
              defaultValue={purchaseRequestLine.contract}
              validate={required}
            />
          </div>
          <div className="p-2 ">
            <IdentityField
              name="quantity"
              label={t('global.quantity')}
              component={TextFieldAdapter}
              type="number"
              defaultValue={purchaseRequestLine.quantity}
              validate={required}
            />
          </div>
          <div className="p-2 ">
            <IdentityField
              name="requested_shipment_date"
              component={DatePickerAdapter}
              label={t(`entities.purchase_request.requested_shipment_date`)}
              defaultValue={purchaseRequestLine.requested_shipment_date}
            />
          </div>
          <div className="p-2 ">
            <IdentityField
              name="notes"
              label={t(`global.notes`)}
              initialValue={purchaseRequestLine.notes}
              component={TextFieldAdapter}
            />
          </div>
        </EnhancedForm>
      </div>
    </div>
  );
}

export default EditAutomaticPurchaseRequestLine;
